import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Currency from 'components/consumer/Currency';
import InfoTooltip from 'components/consumer/InfoTooltip';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
const PDPPriceSectionUI = t0 => {
  const $ = _c(30);
  const {
    price,
    salePrice,
    leastTieredDiscountedPrice,
    maxTieredDiscountedPrice,
    hasDiscount,
    hasTieredDiscount,
    pdpIsModularBYOProduct,
    variant
  } = t0;
  const t1 = variant === "PDPUpSellProduct";
  const t2 = variant === "PDPUpSellFlyOut";
  const t3 = variant === "PDPExtraOptionSelector";
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = classNames("text-lg font-bold text-gray flex items-center lg:text-xl lg:font-bold", {
      "!text-base !font-bold !flex-wrap lg:!flex-nowrap": t1,
      "lg:w-1/2": t2,
      "!text-base": t3
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== hasDiscount) {
    t5 = !!hasDiscount && <VisuallyHidden>Original price:</VisuallyHidden>;
    $[4] = hasDiscount;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== hasDiscount || $[7] !== pdpIsModularBYOProduct || $[8] !== price) {
    t6 = price === 0 && pdpIsModularBYOProduct ? <span className="text-base font-bold">Add a piece</span> : <Currency data-xc="PDPPrice" className={classNames({
      "text-gray line-through mr-1.5": hasDiscount
    })}>{price}</Currency>;
    $[6] = hasDiscount;
    $[7] = pdpIsModularBYOProduct;
    $[8] = price;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = !hasDiscount;
  let t8;
  if ($[10] !== hasDiscount || $[11] !== t7) {
    t8 = classNames("!mr-2", {
      "!ml-0": hasDiscount,
      "!ml-2": t7
    });
    $[10] = hasDiscount;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="text-xs m-0 normal-case" data-xc="PDPPriceTooltipText">Price is subject to change dependent upon zip code of delivery address</div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8) {
    t10 = <InfoTooltip withArrow={true} modifier="brand-fade" openOnHover={true} width={250} showCloseButton={false} iconSize="big" iconDataXc="PDPPriceInfoIcon" className="bottom-px" iconClassName={t8}>{t9}</InfoTooltip>;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== hasDiscount || $[17] !== hasTieredDiscount || $[18] !== leastTieredDiscountedPrice || $[19] !== maxTieredDiscountedPrice || $[20] !== price || $[21] !== salePrice || $[22] !== variant) {
    t11 = !!hasDiscount && <><VisuallyHidden>Price:</VisuallyHidden><Currency data-xc="PDPSalePrice" className="text-red">{hasTieredDiscount ? maxTieredDiscountedPrice : salePrice}</Currency>{hasTieredDiscount && leastTieredDiscountedPrice !== maxTieredDiscountedPrice && <><span className="mx-1">-</span><Currency data-xc="PDPSalePriceRange" className="text-red">{leastTieredDiscountedPrice}</Currency></>}<span className={classNames("text-xs ml-2 text-red flex min-h-[24px] items-center", {
        "!flex-wrap !ml-0 lg:!ml-1.5 lg:!flex-nowrap": variant === "PDPUpSellProduct",
        "!ml-1.5": variant === "PDPExtraOptionSelector"
      })}>{hasTieredDiscount ? `(Save up to $${price - maxTieredDiscountedPrice})` : `(Save $${price - salePrice})`}</span></>;
    $[16] = hasDiscount;
    $[17] = hasTieredDiscount;
    $[18] = leastTieredDiscountedPrice;
    $[19] = maxTieredDiscountedPrice;
    $[20] = price;
    $[21] = salePrice;
    $[22] = variant;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
    t12 = <div className={t4} data-xc="PDPPriceSection">{t5}{t6}{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};
PDPPriceSectionUI.propTypes = {
  price: PropTypes.number,
  salePrice: PropTypes.number,
  leastTieredDiscountedPrice: PropTypes.number,
  maxTieredDiscountedPrice: PropTypes.number,
  hasDiscount: PropTypes.bool,
  hasTieredDiscount: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  variant: PropTypes.oneOf(['PDPExtraOptionSelector', 'PDPUpSellProduct', 'PDPUpSellFlyOut'])
};
export default PDPPriceSectionUI;